import { css } from '@emotion/react';
import { Color } from "../../constants/Colors";

export const useStyles = (props) => ({
  input: css({
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0,
  }),

  label: css({
    display: "block",
    position: "relative",
    paddingLeft: "40px",
    lineHeight: "16px",
    cursor: "pointer",
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    fontFamily: "roboto",
    fontSize: "14px",
    "&::before": {
      boxSizing: "border-box",
      position: "absolute",
      content: "''",
      top: 0,
      left: 0,
      height: "16px",
      width: "16px",
    },
    "&:hover": {
      fontFamily: "roboto-medium",
      "&::before": {
        border: `2px solid ${Color.primary[500]}`,
      },
    },
    "$input:checked ~ &": {
      fontFamily: "roboto-medium",
      "& $checkmark": {
        display: "block",
      },
    },
    "&$disabled": {
      fontFamily: "roboto-medium",
      color: Color.neutral[300],
      "&::before": {
        backgroundColor: Color.neutral[300],
        border: "none",
      },
      "&:hover::before": {
        backgroundColor: Color.neutral[300],
        border: "none",
      },
    },
    "&$error": {
      "&::before": {
        border: `2px solid ${Color.danger[400]}`,
        color: Color.neutral[900],
      },
    },
  }),

  checkmark: css({
    position: "absolute",
    top: 0,
    left: 0,
    height: "16px",
    width: "16px",
    zIndex: 1,
    color: Color.primary[400],
    display: "none",
    "&$disabled": {
      color: Color.neutral[100],
    },
  }),

  n900: css({
    color: Color.neutral[900],
    "&::before": {
      border: `1px solid ${Color.primary[100]}`,
      backgroundColor: Color.neutral[100],
    },
  }),

  n000: css({
    color: Color.neutral[0],
    "&::before": {
      backgroundColor: Color.neutral[0],
    },
  }),

  disabled: {},

  error: {},
});
